import { useGetLatestLecture } from '#api/member';
import { useScheduleManage } from '#providers/SchedulesManage';
import { useDashboardCustomerMembershipState } from '../dahsboardCustomerMembershipState';

export const useItemList = (personId: string) => {
  const { selectedLecture } = useScheduleManage();

  const { data } = useGetLatestLecture(personId, selectedLecture.lectureId);

  const { dashboardCustomerMembershipState } =
    useDashboardCustomerMembershipState();

  const ROUND_OPTUIONS_LENGTH = 1000;

  const totalRoundOptions = Array.from(
    { length: ROUND_OPTUIONS_LENGTH },
    (_, i) => i + 1
  ).map(i => ({ label: `${i}회차` || '', value: i || 0 }));

  const roundOptions = Array.from(
    { length: data?.round || dashboardCustomerMembershipState.totalRound },
    (_, i) => i + 1
  ).map(i => ({ label: `${i}회차` || '', value: i || 0 }));

  roundOptions.unshift({ label: '없음', value: 0 });

  const itemList = [
    {
      view: '수업',
      type: 'view',
      name: 'lectureId',
      options: [
        { label: '30분', value: 30 },
        { label: '50분', value: 50 },
        { label: '60분', value: 60 }
      ]
    },
    {
      view: '수업시간',
      type: 'select',
      name: 'sessionDuration',
      options: [
        { label: '30분', value: 30 },
        { label: '50분', value: 50 },
        { label: '60분', value: 60 }
      ]
    },
    {
      view: '개시 날짜',
      type: 'date',
      name: 'startedDate',
      format: 'YYYY-MM-DD',
      default: '오늘 날짜' // 기본값: 당일 날짜로 설정
    },
    {
      view: '유효기간',
      type: 'select',
      name: 'expiryPeriod',
      options: [
        { label: '없음', value: 0 },
        { label: '30일', value: 30 },
        { label: '60일', value: 60 },
        { label: '90일', value: 90 },
        { label: '직접 선택', value: 'custom' } // 직접 선택 시 만료 날짜 선택 가능
      ]
    },
    {
      view: '만료 날짜',
      type: 'view',
      name: 'expiryDate',
      format: 'YYYY-MM-DD'
    },
    {
      view: '총 회차',
      type: 'select',
      name: 'totalRound',
      options: totalRoundOptions // 총 회차를 선택하기 위한 옵션 리스트
    },
    {
      view: '현재 회차',
      type: 'select',
      name: 'round',
      options: roundOptions // 현재 회차를 선택하기 위한 옵션 리스트
    },
    {
      view: '할인',
      type: 'modal',
      name: 'discount',
      options: []
    },
    {
      view: '결제 상태',
      type: 'select',
      name: 'isRequestPayment',
      options: [
        { label: '결제 예정', value: true },
        { label: '결제 완료', value: false }
      ] // 결제 상태를 선택하기 위한 옵션 리스트
    }
  ];

  return { itemList };
};
